import { defineNuxtPlugin } from '#app/nuxt'
import { LazyContentDoc, LazyContentList, LazyContentNavigation, LazyContentQuery, LazyContentRenderer, LazyContentRendererMarkdown, LazyContentSlot, LazyDocumentDrivenEmpty, LazyDocumentDrivenNotFound, LazyMarkdown, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseCodeInline, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl } from '#components'
const lazyGlobalComponents = [
  ["ContentDoc", LazyContentDoc],
["ContentList", LazyContentList],
["ContentNavigation", LazyContentNavigation],
["ContentQuery", LazyContentQuery],
["ContentRenderer", LazyContentRenderer],
["ContentRendererMarkdown", LazyContentRendererMarkdown],
["ContentSlot", LazyContentSlot],
["DocumentDrivenEmpty", LazyDocumentDrivenEmpty],
["DocumentDrivenNotFound", LazyDocumentDrivenNotFound],
["Markdown", LazyMarkdown],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseCodeInline", LazyProseCodeInline],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
